import { api } from '..';
import {
  ActivateNotificationChannelResponse,
  ConfirmNotificationChannelResponse,
  DriverSelectedNotificationTypeResponse,
  NotificationTypesResponse,
} from './types';

export * from './types';

export const fetchNotificationTypesService = async (params: {
  driverId: string;
}) => {
  const { driverId } = params;
  return await api
    .get<NotificationTypesResponse>(
      `notifications/driver/${driverId}/types`,
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err.response.data));
};

export const fetchDriverSelectedNotificationTypeService = async (params: {
  driverId: string;
}) => {
  const { driverId } = params;
  return await api
    .get<DriverSelectedNotificationTypeResponse>(
      `notifications/driver/${driverId}/types/selected`,
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err.response.data));
};

export const activateNotificationChannelService = async (params: {
  driverId: string;
  notificationType: number;
}) => {
  const { driverId, notificationType } = params;
  return await api
    .post<ActivateNotificationChannelResponse>(
      `notifications/driver/${driverId}/types/activate`,
      JSON.stringify({ notificationType }),
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err.response.data));
};

export const confirmNotificationChannelService = async (params: {
  driverId: string;
  notificationType: number;
  code: string;
}) => {
  const { driverId, notificationType, code } = params;
  return await api
    .post<ConfirmNotificationChannelResponse>(
      `notifications/driver/${driverId}/types/activate/confirm`,
      JSON.stringify({ notificationType, code }),
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err.response.data));
};
